export type WriteStamp = {
    clientWriteId: string;
    actorId: string;
    deviceId: string;
    wallTimeMs: number;
    logicalCounter: number;
};

export type WriteOperationStatus =
    | 'pending'
    | 'retryable'
    | 'applied'
    | 'superseded'
    | 'conflict_review'
    | 'rejected';

export type ProjectWriteOperation = {
    id: string;
    scope: { orgId: string; projectId: string };
    actorId: string;
    deviceId: string;
    stamp: WriteStamp;
    feature:
        | 'setup_access'
        | 'script_show'
        | 'people_casting'
        | 'notifications_email'
        | 'schedule'
        | 'notes_reports'
        | 'files'
        | 'blocking_choreography'
        | 'attendance'
        | 'action_items'
        | 'department_tracking'
        | 'performance'
        | 'admin_adjacent';
    capability: string;
    conflictUnit: string;
    kind:
        | 'setField'
        | 'patchEntity'
        | 'deleteEntity'
        | 'replaceArtifact'
        | 'deleteArtifact'
        | 'sideEffectCommand'
        | 'orderedListCommand'
        | 'reviewOnly';
    payload: unknown;
    createdAtMs: number;
};

export type ProjectWriteResult = {
    operationId: string;
    status: Exclude<WriteOperationStatus, 'pending'>;
    reason?: string;
    conflictId?: string;
    appliedAtMs?: number;
};

export function isTerminalWriteStatus(status: WriteOperationStatus): boolean {
    return status === 'applied' || status === 'superseded' || status === 'conflict_review' || status === 'rejected';
}
